import { getDimensionInfo } from './getDimensionInfo';

export const getVoronoiBlacklist = (
	dimensionInfo: ReturnType<typeof getDimensionInfo>,
) =>
	dimensionInfo
		.map(({ chartColor: { colorId } }) => [
			`scatter-${colorId}`,
			`area-${colorId}`,
			`line-${colorId}`,
		])
		.flat();
